import { api } from "../lib/axios";

export const getTransactionId = async (stationId: string) => {
  const response = await api.get(`/transaction/${stationId}/`);
  return response.data;
};

export const getTransactionDetails = async (stationId: string) => {
  const response = await api.get(`/transaction/details/${stationId}/`);
  return response.data;
};

export const getTransactionDetailsInfo = async (transactionId: string) => {
  const response = await api.get(`/transaction/details-info/${transactionId}/`);
  return response.data;
};
